import React, { useMemo } from "react"
import CollapsibleDataTable from "./CollapsibleDataTable"
import StockModelCell from "components/Common/stock-table/StockModelCell"
import MovementInfoCell from "components/Common/VehicleMovement/MovementInfoCell"
import { formatReadableDate } from "utils/formatDate"

const MovementKeyList = ({ data = [], loading = false, onPageChange }) => {
  const columns = useMemo(
    () => [
      {
        id: "expander",
        header: "",
        cell: () => null, // handled in table
      },
      {
        header: "Vehicle Info",
        accessorKey: "vehicle_info",
        cell: ({ row }) => (
          <StockModelCell
            stock={row.original ?? {}}
            isMobile={false}
            isExpanded={() => false}
            toggleRow={() => {}}
            rowId={row.original?.stock_id}
            showIdentifiers
            showImage
          />
        ),
      },
      {
        header: "Latest Movement Info",
        accessorKey: "latest_movement_info",
        cell: ({ row }) => (
          <MovementInfoCell data={row.original?.movements?.[0]} />
        ),
      },
      {
        header: "Remarks",
        accessorKey: "remarks",
        cell: ({ row }) => {
          const movements = row.original?.movements || []
          const latest = movements?.[0] || {}
          return latest.remarks || "-"
        },
      },
      {
        header: "Date",
        accessorKey: "created_at",
        cell: ({ row }) => {
          const movements = row.original?.movements || []
          const latest = movements?.[0] || {}
          return latest?.created_at
            ? formatReadableDate(latest?.created_at)
            : "-"
        },
      },
    ],
    []
  )

  const renderSubComponent = ({ row }) => {
    // All movements except the latest for history table
    const childData = row.original?.movements?.slice(1) || []
    if (!childData.length)
      return <div className="text-muted p-2">No previous movements</div>

    return (
      <table className="table table-sm mb-0">
        <thead>
          <tr>
            <th>Date</th>
            <th>Type</th>
            <th>From</th>
            <th>To</th>
            <th>Mileage</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {childData.map((child, i) => (
            <tr key={i}>
              <td>{formatReadableDate(child.movement_date)}</td>
              <td>{child?.movement_type?.name || "-"}</td>
              <td>{child?.location_from?.name || "-"}</td>
              <td>{child?.location_to?.name || "-"}</td>
              <td>{`${child?.mileage?.toLocaleString() || 0} km`}</td>
              <td>{child?.remarks || "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }

  return (
    <CollapsibleDataTable
      columns={columns}
      data={data?.data || []}
      renderSubComponent={renderSubComponent}
      childKey="movements"
      paginationInfo={data}
      loading={loading}
      isPagination={true}
      onPageChange={onPageChange}
    />
  )
}

export default MovementKeyList
